import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.object.freeze";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as filledStar } from '@fortawesome/free-solid-svg-icons/faStar';
import styles from './StarRating.css';
var cx = classnames.bind(styles);
var SIZE_MAP = {
  sm: 'sm',
  lg: '1x'
};
var ITERATOR = Object.freeze(Array(5).fill(true));
var StarGroup = React.memo(function (_ref) {
  var size = _ref.size;
  return ITERATOR.map(function () {
    return React.createElement(FontAwesomeIcon, {
      icon: filledStar,
      size: size
    });
  });
});

function StarRating(_ref2) {
  var starCount = _ref2.starCount,
      reviewCount = _ref2.reviewCount,
      size = _ref2.size;
  return React.createElement("div", {
    className: cx('rating')
  }, React.createElement("div", {
    className: cx('stars')
  }, React.createElement("span", {
    className: cx('starsBack')
  }, React.createElement(StarGroup, {
    size: SIZE_MAP[size]
  })), React.createElement("span", {
    className: cx('starsFront'),
    style: {
      width: "".concat(starCount / 5 * 100, "%")
    }
  }, React.createElement(StarGroup, {
    size: SIZE_MAP[size]
  }))), reviewCount !== false && React.createElement("div", {
    className: cx('count')
  }, "(", reviewCount, ")"));
}

StarRating.displayName = 'StarRating';
StarRating.propTypes = {
  starCount: PropTypes.number.isRequired,
  reviewCount: PropTypes.number,
  size: PropTypes.number
};
StarRating.defaultProps = {
  size: 'sm',
  reviewCount: undefined
};
export default React.memo(StarRating);